<template>
    <a class="list-page__item list-page__item-connected" :href="item.url">
        <div class="list-page__item-content-connected">
            <Heading v-if="props.item.tags && props.item.tags.length" tag="h2" :data="item.heading"></Heading>
            <Heading v-else tag="h2" :data="item.heading"></Heading>
            <p v-html="item.cardIntro"></p>
            <p class="read-more">{{props.item.linkText}}<span class="icon icon--bark-dark icon--arrow-right"></span></p>
        </div>
    </a>
</template>


<script setup>
    import Heading from '@/vue/elements/heading.vue';
    import { onMounted, onBeforeMount, computed, reactive, ref } from 'vue';
    const props = defineProps({
        item: {}
    })

    /* Computed ---------------------------*/

    /* Lifecycle Hooks -------------------*/
    onBeforeMount(() => {});

    onMounted(() => {});
</script>